import { render, staticRenderFns } from "./OneOfGroupIngredient.vue?vue&type=template&id=4ff75d58&"
import script from "./OneOfGroupIngredient.vue?vue&type=script&lang=ts&"
export * from "./OneOfGroupIngredient.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports